@if (data$ | async; as item) {
  <div class="banner-products" [style]="'background-color :'+ item.background">
    <div class="container">
      @switch (item.titleTag) {
        @case ('H1') {
          <h1 class="h2-component" [style]="'font-weight :'+ (item.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ item.titleSize +'px; color: '+ item.titleColor">{{item.title}}</h1>
        }
        @case ('H2') {
          <h2 class="h2-component" [style]="'font-weight :'+ (item.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ item.titleSize +'px; color: '+ item.titleColor">{{item.title}}</h2>
        }
        @default {
          <div class="h2-component" [style]="'font-weight :'+ (item.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ item.titleSize +'px; color: '+ item.titleColor">{{item.title}}</div>
        }
      }
      <!--      {{items$ | async}}-->
      <div class="{{item.isImageBelowProducts == 'true' ? 'default-container' : 'reverse-container'}}">
        <app-custom-ohgar-text-static-banner class="container-banner-camel" [item]="item.image "></app-custom-ohgar-text-static-banner>
        @if (items$ | async) {
          <div class="product-carousel">
            <ng-container *ngTemplateOutlet="carousel"></ng-container>
          </div>
        }
      </div>
    </div>
  </div>
}

<ng-template #carousel>
  @if ((isMobile() | async)) {
    <cx-carousel
      [items]="items$ | async"
      [template]="carouselItem"
      itemWidth="50%"
      [hideIndicators]="true"
      [hideButtons]="false"
      [animation]="animation"
      >
    </cx-carousel>
  } @else {
    <cx-carousel
      [items]="items$ | async"
      [template]="carouselItem"
      itemWidth="300px"
      [hideIndicators]="true"
      [hideButtons]="false"
      [animation]="animation"
      >
    </cx-carousel>
  }

</ng-template>

<ng-template #carouselItem let-item="item">
  <app-custom-product-item [item]="item"></app-custom-product-item>
</ng-template>
